import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const buildFiles = (response) => {
  if (!response) return [];
  if (Array.isArray(response.files)) {
    return response.files;
  }
  return [];
};

export default function EntUploadSummary() {
  const location = useLocation();
  const navigate = useNavigate();

  const entResponse = location.state?.entResponse || null;
  const entImagesCount = location.state?.entImagesCount ?? entResponse?.count ?? 0;
  const files = buildFiles(entResponse);
  const successStatus = entResponse?.success;

  const handleBackToTests = () => {
    navigate("/general-test", { replace: true });
  };

  const hasData = Boolean(entResponse) && files.length > 0;

  return (
    <div className="min-h-screen bg-[#F1EEFF] flex flex-col items-center py-10 px-6">
      <div className="bg-white w-full max-w-3xl rounded-3xl shadow-lg p-8 space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-[#845BB3]">ENT Upload Summary</h1>
          <p className="text-gray-500 mt-1">
            {hasData
              ? "Below are the images uploaded for this patient's ENT assessment."
              : "No ENT upload details were found for this session."}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="p-4 rounded-xl border border-[#E0DDF5] bg-[#F7F5FF]">
            <p className="text-sm text-gray-500">Upload Status</p>
            <p className={`text-lg font-semibold ${successStatus ? "text-green-600" : "text-red-500"}`}>
              {successStatus === undefined
                ? "Unavailable"
                : successStatus
                ? "Success"
                : "Failed"}
            </p>
          </div>
          <div className="p-4 rounded-xl border border-[#E0DDF5] bg-[#F7F5FF]">
            <p className="text-sm text-gray-500">Images Count</p>
            <p className="text-lg font-semibold text-[#845BB3]">{entImagesCount}</p>
          </div>
        </div>

        {files.length > 0 ? (
          <div className="space-y-3">
            <p className="text-sm font-semibold text-[#845BB3]">Uploaded Files</p>
            <div className="grid gap-4 sm:grid-cols-2">
              {files.map((fileUrl, idx) => (
                <div
                  key={`${fileUrl}-${idx}`}
                  className="flex flex-col rounded-xl border border-[#E0DDF5] bg-[#F8F6FF] overflow-hidden"
                >
                  <div className="w-full h-40 bg-[#EDE9FF] flex items-center justify-center overflow-hidden">
                    <img
                      src={fileUrl}
                      alt={`ENT ${idx + 1}`}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  </div>
                  <div className="p-4 space-y-2">
                    <p className="text-sm font-semibold text-[#4C4A64]">Image {idx + 1}</p>
                    <button
                      type="button"
                      onClick={() => window.open(fileUrl, "_blank")}
                      className="px-4 py-2 text-sm font-medium rounded-lg bg-white border border-[#845BB3] text-[#845BB3] hover:bg-[#F1EEFF]"
                    >
                      Open in new tab
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="p-4 rounded-xl border border-[#E0DDF5] bg-[#FFF9F2] text-[#845BB3]">
            No ENT images were uploaded or the session data has expired.
          </div>
        )}

        <button
          onClick={handleBackToTests}
          className="w-full px-6 py-3 rounded-xl bg-white border border-[#845BB3] text-[#845BB3] font-semibold hover:bg-[#F7F5FF]"
        >
          Back to Tests
        </button>
      </div>
    </div>
  );
}
